/**
 * Read boss mobile dashboard telemetry from Firestore `boss_dashboard_activities`.
 * Written by BossDashboardActivityService.log() in the Flutter app.
 */
import { collection, getDocs, limit, orderBy, query } from "firebase/firestore";
import { db } from "../firebase";

export const COLLECTION_BOSS_DASHBOARD_ACTIVITIES = "boss_dashboard_activities";

const DEFAULT_LIMIT = 500;

function tsMillis(v) {
  if (!v) return 0;
  if (typeof v?.toDate === "function") {
    const d = v.toDate();
    return Number.isNaN(d.getTime()) ? 0 : d.getTime();
  }
  if (typeof v?.seconds === "number") return v.seconds * 1000;
  if (typeof v?._seconds === "number") return v._seconds * 1000;
  const d = v instanceof Date ? v : new Date(v);
  return Number.isNaN(d.getTime()) ? 0 : d.getTime();
}

/**
 * @param {number} [maxRows]
 * @returns {Promise<Array<{ id: string } & Record<string, unknown>>>}
 */
export async function fetchBossDashboardActivities(maxRows = DEFAULT_LIMIT) {
  const col = collection(db, COLLECTION_BOSS_DASHBOARD_ACTIVITIES);
  const cap = Math.min(Math.max(1, Number(maxRows) || DEFAULT_LIMIT), 2000);

  try {
    const qy = query(col, orderBy("timestamp", "desc"), limit(cap));
    const snap = await getDocs(qy);
    return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
  } catch (e) {
    console.warn("fetchBossDashboardActivities orderBy failed, loading unsorted:", e?.message);
    const snap = await getDocs(query(col, limit(cap)));
    const rows = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
    rows.sort((a, b) => tsMillis(b.timestamp) - tsMillis(a.timestamp));
    return rows;
  }
}

export { tsMillis as bossActivityTimestampMillis };
